import { render } from "./ProcessRequest.vue?vue&type=template&id=b6672926&scoped=true"
import script from "./ProcessRequest.vue?vue&type=script&lang=js"
export * from "./ProcessRequest.vue?vue&type=script&lang=js"

import "./ProcessRequest.vue?vue&type=style&index=0&id=b6672926&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6672926"]])

export default __exports__